import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import getSocketMiddlewareInstance from '../../common/SocketMiddleware';

const apiCaller = getApiInstance();

function getSDM17SPGs() {
    return dispatch => {
        return apiCaller
            .call(api.getAllSDM17SPGs())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHEPOOL__FHEPRODUCT_SET_SDM17SPGS',
                        SDM17SPGs: data.SDM17SPGs
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFHEPoolSDM17SPGs - ', error);
                throw error;
            });
    };
}
function getSDM17SPGDetails(SDM17SPGId) {
    return dispatch => {
        return apiCaller
            .call(api.getSDM17SPGDetails(SDM17SPGId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHEPOOL__FHEPRODUCT_SET_SDM17SPG_DETAILS',
                        SDM17SPGId: data.SDM17SPGDetails.macAddress,
                        SDM17SPGDetails: data.SDM17SPGDetails
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFHEPoolSDM17SPGDetails - ', error);
                throw error;
            });
    };
}
function refreshSDM17SPGStatus(SDM17SPGMac) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductCheckStatus('SDM17SPG', SDM17SPGMac)
            .catch(error => {
                Logger.log('dataActions: refreshFHEPoolSDM17SPGStatus - ', error);
                throw error;
            });
    };
}
function dissociateSDM17SPGUser(SDM17SPGMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUser('SDM17SPG', SDM17SPGMac, userId)
            .catch(error => {
                Logger.log('dataActions: dissociateSDM17SPGUser - ', error);
                throw error;
            });
    };
}
function dissociateSDM17SPGUserAndSwitchMaster(SDM17SPGMac, userId, masterId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductDissociateUserAndSwitchMaster('SDM17SPG', SDM17SPGMac, userId, masterId)
            .catch(error => {
                Logger.log('dataActions: dissociateSDM17SPGUserAndSwitchMaster - ', error);
                throw error;
            });
    };
}
function switchSDM17SPGMaster(SDM17SPGMac, userId) {
    return () => {
        return getSocketMiddlewareInstance()
            .FHEProductMasterSwitch('SDM17SPG', SDM17SPGMac, userId)
            .catch(error => {
                Logger.log('dataActions: switchFHEPoolSDM17SPGMaster - ', error);
                throw error;
            });
    };
}

export {
    getSDM17SPGs,
    getSDM17SPGDetails,
    refreshSDM17SPGStatus,
    dissociateSDM17SPGUser,
    dissociateSDM17SPGUserAndSwitchMaster,
    switchSDM17SPGMaster
};



// WEBPACK FOOTER //
// ./environments/fhepool/data/SDM17SPG/actions.js